import { TrackableStatus } from '@/shared/models';
import { addItemToWorkflowTable } from '@/warehouse/helpers';
/** Works for both caches: with *receipted* invoices and with *not receipted* invoices. */
export function updateVerificationReceiptItemsByMessage({ draft, message,
// endpointName,
// eventName,
 }) {
    const itemIndex = draft.findIndex((item) => item.receiptItemId === message.receiptItemId);
    if (itemIndex === -1 && message.isDeletion) {
        const verificationReceiptItem = {
            invoice: {
                invoiceId: message.invoiceId,
                invoiceNumber: message.invoiceNumber,
                invoiceDate: new Date(message.invoiceDate),
                supplierName: message.supplierName,
            },
            receiptItemId: message.receiptItemId,
            invoiceId: message.invoiceId,
            // article: message.article,
            // brand: message.brand,
            // name: message.name,
            article: '!!UNKNOWN_ARTICLE',
            brand: '!!UNKNOWN_BRAND',
            name: '!!UNKNOWN_NAME',
            quantity: message.itemQuantity,
            receiptedQuantity: message.itemReceiptedQuantity,
            blockedQuantity: message.itemBlockedQuantity,
            // orderId: message.orderId,
            orderId: 0, // '!!UNKNOWN_ORDER_ID'
            // userName: message.userName,
            userName: '!!UNKNOWN_USER_NAME',
            // trackableStatus: message.trackableStatus,
            trackableStatus: TrackableStatus.None, // TODO: fix also
        };
        addItemToWorkflowTable(draft, verificationReceiptItem, 'receiptItemId');
        // // TODO: (later) add error log to backend.
        // // console.error(`In ${endpointName}() onCacheEntryAdded '${eventName}' event has wrong id: `, stockInvoice.stockInvoiceId);
        // console.error(`In ${endpointName}() onCacheEntryAdded 'CreateOrDeleteStickerItem' event has wrong id: `, message.receiptItemId);
        // console.log(`VerificationReceiptItem is not found in Verification tab list`);
        // console.log('Draft:', current(draft));
        // console.log('message ', message);
        // return;
    }
    else {
        draft[itemIndex].receiptedQuantity = message.itemReceiptedQuantity;
        draft[itemIndex].blockedQuantity = message.itemBlockedQuantity;
    }
}
